import { Component, OnInit } from '@angular/core';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit {

  clientCards$: any;

  loader: boolean = true;

  constructor(
    private stripeApi: MyStripeService,
    private tools: ToolsService
  ) { }

  ngOnInit() {
 

    this.tools.setPageClient("cards");

    
    // this.stripeApi.getCards().subscribe((cards:any) => {
    //   this.clientCards$ = cards;
    //   this.loader = false;
    // });


    this.stripeApi.getPaymentMethod().subscribe((cards:any) => {
   
      this.clientCards$ = cards;
      this.loader = false;
    });

  }

  setClientCards(cards: any[]) {
    this.clientCards$ = cards;
  }

}
